import { Component, OnInit } from '@angular/core';
import { PayService } from '../service/pay.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-affaires-mensualites',
  templateUrl: './affaires-mensualites.component.html',
  styleUrls: ['./affaires-mensualites.component.css'],
  standalone: false
})
export class AffairesMensualitesComponent implements OnInit {
  accountNumber: any;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();
  mensuellist: any[] = [];
  allMensualites: any[] = [];
  monthOptions: { value: string; label: string }[] = [];
  selectedMonth: string;
  sigle: string;
  bDescription: string;
  safeName: string;
  constructor(private userService: PayService, private routerActivate: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    $('#utilisateur').DataTable().init;
    this.routerActivate.params.subscribe(params => {
      this.accountNumber = params['id']

    });
    this.sigle = localStorage.getItem('sigle');
    const raw = localStorage.getItem("bDescription");
    this.bDescription = raw ? decodeURIComponent(raw) : '';
    this.safeName = encodeURIComponent(this.bDescription);
    this.getMensuellist();
  }


  getMensuellist() {
    $('#utilisateur').DataTable().destroy();
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      responsive: true
    };
    this.userService.getUtilisateursBaccountMensualites(this.accountNumber).subscribe((data: any[]) => {
      this.dtTrigger.next();
      this.allMensualites = data || [];
      this.buildMonthOptions();
      this.applyMonthFilter(this.selectedMonth);
      console.log(data)
    })
  }

  applyMonthFilter(monthKey: string) {
    this.selectedMonth = monthKey || this.getCurrentMonthKey();
    this.mensuellist = this.allMensualites.filter(m => this.getMonthKeyFromParts(m?.annee, m?.month) === this.selectedMonth);
  }

  private buildMonthOptions() {
    const months = new Set<string>();
    const current = this.getCurrentMonthKey();
    months.add(current); // always include current month
    this.allMensualites.forEach(m => {
      const key = this.getMonthKeyFromParts(m?.annee, m?.month);
      if (key) { months.add(key); }
    });
    this.monthOptions = Array.from(months)
      .sort((a, b) => b.localeCompare(a)) // newest first
      .map(key => ({ value: key, label: this.formatMonthLabel(key) }));
    this.selectedMonth = current;
  }

  private getMonthKeyFromParts(year: any, month: any): string {
    if (year == null || month == null) { return ''; }
    const m = Number(month);
    const y = Number(year);
    if (isNaN(m) || isNaN(y)) { return ''; }
    const paddedMonth = String(m).padStart(2, '0');
    return `${y}-${paddedMonth}`;
  }

  private getCurrentMonthKey(): string {
    const now = new Date();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    return `${now.getFullYear()}-${month}`;
  }

  private formatMonthLabel(key: string): string {
    const [year, month] = key.split('-').map(Number);
    const d = new Date(year, (month || 1) - 1);
    return d.toLocaleString('fr-FR', { month: 'long', year: 'numeric' });
  }
}
